import { AnimationControls, motion } from 'framer-motion'
import { useAnimation } from 'framer-motion'
import times from 'lodash/times'
import React, { useCallback, useEffect } from 'react'
import { useMeasure } from 'react-use'
import styled from 'styled-components'
import { LevelIcon } from './LevelIcon'

const sizes = [24, 16, 12, 8, 4]
const colors = ['#0C5A4B', '#C3FF8E', '#2329AE', '#7EC6F8', '#FF3865', '#CDA5FF', '#FFF05C', '#FF895E', '#a80101']

const AnimatedContainer = styled(motion.div)`
  position: relative;
`

const LevelWrapper = styled.div`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Celebration = styled.div`
  display: flex;
  align-items: flex-end;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  pointer-events: none;
  z-index: 100;
  justify-content: space-between;
  overflow: hidden;
`
interface ContentProps {
  offset: number
  icon?: React.ReactNode
  controls: AnimationControls
  level: number
}

interface Props {
  children: React.ReactNode
  level: number
}

const rotationAmount = 5
const maxDelay = 800
const minDuration = 400
const maxDuration = 700

export const LevelAnimationContent = ({ offset, controls, level }: ContentProps) => {
  const rotationDirection = Math.random() >= 0.5 ? 1 : -1
  const rotation = rotationDirection * rotationAmount

  const delay = maxDelay * Math.random()
  const duration = minDuration + Math.random() * maxDuration

  const size = sizes[Math.floor(Math.random() * (sizes.length - 1))]

  const color = colors[Math.floor(Math.random() * (colors.length - 1))]

  return (
    <AnimatedContainer
      style={{ rotateZ: rotation }}
      transition={{ ease: 'linear', delay: delay / 1000, type: 'tween', duration: duration / 600, times: [0, 0.1, 1] }}
      initial={{ opacity: 0, bottom: '-20%', x: offset }}
      animate={controls}>
      <LevelWrapper
        style={{
          width: size,
          height: size,
          backgroundColor: color
        }}>
        <LevelIcon level={level} size="60%" variant="shape" />
      </LevelWrapper>
    </AnimatedContainer>
  )
}

export const LevelUpAnimation = ({ children, level }: Props) => {
  const [ref, { width }] = useMeasure<HTMLDivElement>()
  const controls = useAnimation()
  const icons = times(20, () => ({ offset: Math.random() * width }))

  const animateIcons = useCallback(() => {
    controls.set({ bottom: '0%', opacity: 0 })
    controls.start({ bottom: '120%', opacity: [0, 1, 0] })
  }, [controls])

  useEffect(() => {
    if (icons.length) {
      animateIcons()
    }
  }, [icons, animateIcons])

  return (
    <>
      {children}
      <Celebration ref={ref}>
        {icons.map((icon, ix) => (
          <LevelAnimationContent level={level} controls={controls} offset={icon.offset} key={ix} />
        ))}
      </Celebration>
    </>
  )
}
